import { useCallback, useEffect, useState } from 'react';
import { Spinner } from 'components/common/Spinner';

import styles from './styles.module.css';

type Props = {
    loadMore?: () => void
    className?: string
}

export const LoadMore: React.FC<Props> = ({
    loadMore,
    className,
}) => {
    const { setRef } = useInView({ onIntersect: loadMore })
    const _className = className ? `${className} ${styles.loading}` : styles.loading
    return <Spinner className={_className} ref={setRef} />
}

const useInView = (options: {
    onIntersect?: () => void
    root?: Element | Document | null
    rootMargin?: string
    threshold?: number | number[]
}) => {
    const { onIntersect, root, rootMargin, threshold } = options
  
    const [inView, setInView] = useState(false)
    const [ref, setRef] = useState<HTMLElement | null>(null)
  
    const handleIntersect = useCallback((entries: IntersectionObserverEntry[]) => {
        const [entry] = entries

        setInView(entry.isIntersecting)
        if (entry.isIntersecting) {
            onIntersect && onIntersect()
        }
    }, [onIntersect])
  
    useEffect(() => {
        if (!ref) {
            setInView(false)
            return
        }

        const observer = new IntersectionObserver(handleIntersect, {
            root,
            rootMargin,
            threshold
        })
        observer.observe(ref)

        return () => {
            observer.unobserve(ref)
        }
    }, [handleIntersect, ref, root, rootMargin, threshold])
  
    return { inView, setRef }
}
